import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressStepsComponent } from '@app/shared/ui/progress-steps/progress-steps.component';
import { InputLabelComponent } from '@app/shared/ui/input-label/input-label.component';
import { InputComponent } from '@app/shared/ui/input/input.component';
import { ButtonDirective } from '@app/shared/directives/button.directive';
import { corporateRoutesConfig } from '@create-account/corporate/corporate-routes.config';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Store } from '@ngxs/store';
import { KycService } from '@app/core/services/client/kyc.service';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '@app/core/services/loading.service';
import { Observable, Subscription } from 'rxjs';
import { AuthSelectors } from '@app/auth/store/auth.selectors';
import { CompanyProfileKyc } from '@app/core/models/client/kyc';
import { SlideInRightModalComponent } from '@app/shared/ui/slide-in-right-modal/slide-in-right-modal.component';
import { CreateAccountBankComponent } from '../create-account-bank/create-account-bank.component';

@Component({
  selector: 'app-create-account-company',
  standalone: true,
  imports: [
    CommonModule,
    SlideInRightModalComponent,
    ProgressStepsComponent,
    InputLabelComponent,
    InputComponent,
    ButtonDirective,
    ReactiveFormsModule,
    FormsModule,
    CreateAccountBankComponent
  ],
  templateUrl: './create-account-company.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateAccountCompanyComponent {
  CORPORATE_ROUTES = corporateRoutesConfig;
  @Output() action = new EventEmitter<void>();

  fb = inject(FormBuilder);
  change = inject(ChangeDetectorRef);
  router = inject(Router);
  store = inject(Store);
  kycService = inject(KycService)
  private _toast = inject(ToastrService);
  private loadingService = inject(LoadingService);

  isLoading$!: Observable<boolean>;
  profileID = this.store.selectSnapshot(AuthSelectors.getProfileID);
  accountID = this.store.selectSnapshot(AuthSelectors.getActiveAccountID);
  subs: Subscription[] = [];
  isBankModalOpen: boolean = false;

  companyDetailsForm = this.fb.nonNullable.group({
    name: ['', Validators.required],
    registration_number: ['', Validators.required],
    tin: ['', Validators.required],
    registered_date: ['', Validators.required],
  });

  updateProfile() {

    this.loadingService.setLoading('create-company-profile', true);
    // Prepare the body with form values, profileId and accountId
    const updatePayload: CompanyProfileKyc = {
      // profile_id: this.profileID,
      account_id: this.accountID,
      ...this.companyDetailsForm.getRawValue(),
    };

    const sub = this.kycService
      .addCompanyProfile(updatePayload)
      .subscribe({
        next: (response) => {
          this.loadingService.setLoading('create-company-profile', false);
          this._toast.success('Profile updated successfully');
          this.router.navigateByUrl('/dashboard/corporate/bank')


          this.change.detectChanges();
        },
        error: (resp) => {
          this.loadingService.setLoading('create-company-profile', false);
          this.change.detectChanges();
          this._toast.error('Failed to update profile');
        },
      });

    this.subs.push(sub);

  } constructor() {
    this.isLoading$ = this.loadingService.getLoadingObservable(
      'create-company-profile'
    );
  }

  closeModal(): void {
    history.back()
    // this.action.emit();
  }
  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
  skip(): void {
    this.router.navigateByUrl('/dashboard/corporate/bank')
    // this.isBankModalOpen = !this.isBankModalOpen
  }
}
